module.exports = "/_next/static/images/ByronKeithAdams-792a48b609b67268382b025d29fae684.webp";